import { lazy } from 'react';

export type SandpackEditorProps = {
  content: string;
  onChange: (content: string) => void;
  isReadOnly?: boolean;
  isPreviewMode?: boolean;
  mimeType: string;
  lineNumberFontSize?: string;
  onFlushContent?: (getContent: () => string) => void;
};

export const LazySandpackEditor = lazy<React.ComponentType<SandpackEditorProps>>(() =>
  // @ts-expect-error Module federation dynamic import
  import('OpalChat/SandpackEditor')
    .then(m => ({
      default: m.SandpackEditor,
    }))
    .catch(error => {
      console.error('Failed to load SandpackEditor:', error);
      return {
        default: () => <div>Failed to load code editor</div>,
      };
    })
);
